import { useEffect, useState } from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, AreaChart, Area, CartesianGrid } from "recharts";
import { Eye, Users } from "lucide-react";
import { api } from "@/lib/api";

export default function Analytics() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/analytics/overview").then((r) => setD(r.data)).catch(() => {}); }, []);

  return (
    <div>
      <h1 className="font-heading text-3xl font-black text-ink">Trafic du site</h1>
      <p className="text-ink/50 mt-1">Analyse des visites et des pages les plus consultées.</p>

      <div className="mt-6 grid grid-cols-2 gap-4">
        <div className="bg-card border border-border rounded-xl p-5"><div className="flex items-center gap-3"><div className="h-10 w-10 rounded-lg bg-accent text-primary flex items-center justify-center"><Eye size={20} /></div><div><p className="font-heading text-2xl font-black text-ink">{d?.total_views ?? "—"}</p><p className="text-xs text-ink/50">Pages vues</p></div></div></div>
        <div className="bg-card border border-border rounded-xl p-5"><div className="flex items-center gap-3"><div className="h-10 w-10 rounded-lg bg-accent text-primary flex items-center justify-center"><Users size={20} /></div><div><p className="font-heading text-2xl font-black text-ink">{d?.unique_sessions ?? "—"}</p><p className="text-xs text-ink/50">Visiteurs uniques</p></div></div></div>
      </div>

      <div className="mt-6 bg-card border border-border rounded-xl p-5">
        <h2 className="font-heading font-bold text-ink mb-4">Évolution du trafic (14 jours)</h2>
        <div className="h-72">
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart data={d?.series || []}>
              <defs><linearGradient id="ga" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor="#F39200" stopOpacity={0.4} /><stop offset="100%" stopColor="#F39200" stopOpacity={0} /></linearGradient></defs>
              <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#eee" />
              <XAxis dataKey="date" tick={{ fontSize: 11 }} tickFormatter={(v) => v?.slice(5)} />
              <YAxis tick={{ fontSize: 11 }} width={30} />
              <Tooltip />
              <Area type="monotone" dataKey="views" stroke="#F39200" strokeWidth={2} fill="url(#ga)" />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </div>

      <div className="mt-6 bg-card border border-border rounded-xl p-5">
        <h2 className="font-heading font-bold text-ink mb-4">Pages les plus visitées</h2>
        <div className="h-80">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={d?.top_pages || []} layout="vertical" margin={{ left: 40 }}>
              <XAxis type="number" tick={{ fontSize: 11 }} />
              <YAxis type="category" dataKey="path" tick={{ fontSize: 11 }} width={140} />
              <Tooltip />
              <Bar dataKey="views" fill="#F39200" radius={[0, 4, 4, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}
